<p>{{ content }}
    <ng-container *ngIf="isMore">
    <a class="tutorials-less-more" href="javascript:void(0)" *ngIf="!isContentToggled" (click)="toggleContent()"><i class="fa fa-chevron-circle-down"></i></a>
    <a class="tutorials-less-more" href="javascript:void(0)" *ngIf="isContentToggled" (click)="toggleContent()"><i class="fa fa-chevron-circle-up"></i></a>
</ng-container>
</p>
 